import React from "react"
import App from "./App"
import { CheckCircle, Hourglass, HourglassSplit, XCircle } from 'react-bootstrap-icons';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./redux/store";
import { storeActivityIndicator } from "./redux/reducers/authSlice";


const MainApp = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch();

    return (
        <React.Fragment>

            {
                auth.activityIndicator && (
                    <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', position: 'fixed', top: 0, left: 0, zIndex: 12345, background: 'rgba(0, 0, 0, 0.33)', width: '100%', height: '100%' }}>

                        <div style={{ minWidth: 250, maxWidth: 400, flexDirection: 'column', padding: '20px 30px', borderRadius: 10, display: 'flex', background: 'white' }}>
                            <div className="mb-3" style={{ display: 'flex', alignSelf: 'center' }}>
                                {
                                    auth.activityIndicator.type == 'loading' && (
                                        <HourglassSplit size={42} className="text-warning" />
                                    )
                                }

                                {
                                    auth.activityIndicator.type == 'error' && (
                                        <XCircle size={42} className="text-danger" />
                                    )
                                }

                                {
                                    auth.activityIndicator.type == 'success' && (
                                        <CheckCircle size={42} className="text-success" />
                                    )
                                }
                            </div>

                            {
                                auth.activityIndicator.title && (
                                    <h3 style={{ textAlign: 'center' }}>{auth.activityIndicator.title}</h3>
                                )
                            }

                            {
                                auth.activityIndicator.text && (
                                    <span style={{ textAlign: 'center' }}>{auth.activityIndicator.text}</span>
                                )
                            }

                            {
                                auth.activityIndicator.text2 && (
                                    <span style={{ textAlign: 'center' }}>{auth.activityIndicator.text2}</span>
                                )
                            }


                            {
                                auth.activityIndicator.type == 'success' && (
                                    <button onClick={() => dispatch(storeActivityIndicator(undefined))} className="mt-3 btn btn-success text-white">Tamam!</button>

                                )
                            }

                            {
                                auth.activityIndicator.type == 'error' && (
                                    <button onClick={() => dispatch(storeActivityIndicator(undefined))} className="mt-3 btn btn-danger text-white">Tamam!</button>

                                )
                            }
                        </div>
                    </div>
                )
            }

            <App />
        </React.Fragment>
    )
}

export default MainApp;